import axios from "axios"

const paramsSerializer = (params) => {
    const Qs = require("qs")
    return Qs.stringify(params, { encode: false })
}

export const getSystemParameter = (headers, params) => {
    return axios.get(`${process.env.REACT_APP_MANAGEMENT_API_URL}/system-parameter`, {
        headers,
        params,
        paramsSerializer
    })
}

export const createSystemParameter = (headers, data) => {
    return axios.post(`${process.env.REACT_APP_MANAGEMENT_API_URL}/system-parameter`,
        data,
        {
            headers
        })
}

export const updateSystemParameter = (headers, id, data) => {
    return axios.put(
        `${process.env.REACT_APP_MANAGEMENT_API_URL}/system-parameter/${id}`,
        data,
        {
            headers
        }
    )
}

export const deleteSystemParameter = (headers, id) => {
    return axios.delete(`${process.env.REACT_APP_MANAGEMENT_API_URL}/system-parameter/${id}`, {
        headers
    })
}

export const getValueConfig = (headers, params) => {
    return axios.get(
        `${process.env.REACT_APP_MANAGEMENT_API_URL}/system-parameter/get-value-by-code`,
        {
            headers,
            params,
            paramsSerializer
        },
        { useCache: false }
    )
}

export const getSystemParameterByCode = (headers, code) => {
    return axios.get(
        `${process.env.REACT_APP_MANAGEMENT_API_URL}/system-parameter/find-by-code?code=${code}`, {
        headers
    })
}